import React from 'react';
import { CardTW } from 'tailwindComponents/CardTW/CardTW';
import { IEscrowExpectedIncomingCheckData } from 'types/accounting/data/IEscrowExpectedIncomingCheckData';
import { IPageData } from 'types/rest/IPageData';
import { IPotentialMatch } from './IPotentialMatch';
import { ExpectedDisplay } from './ExpectedDisplay';

export interface IExpectedCheckTableDisplayProps {
  data: IPageData<IEscrowExpectedIncomingCheckData>;
  accountNumber: string;
  setPotentialMatch: (x: IPotentialMatch) => void;
}

export const ExpectedCheckTableDisplay: React.FC<IExpectedCheckTableDisplayProps> = ({
  data,
  setPotentialMatch,
  accountNumber,
}) => {
  return (
    <CardTW
      title={
        <>
          Orders Expecting Checks
          {data && (
            <span className="ml-8 rounded-full bg-green-100 px-2 py-1 align-middle text-xs font-medium text-green-700">
              {data.content.length} Item{data.content.length === 1 ? '' : 's'}
            </span>
          )}
        </>
      }
      isCollapsible
      isCollapsed
      contentClassName={'px-0'}
    >
      <div>
        {data.content.map((expectedCheck) => (
          <ExpectedDisplay
            key={expectedCheck.id}
            expected={expectedCheck}
            actionLabel={'Match'}
            accountNumber={accountNumber}
            onAction={() => setPotentialMatch({ expectedCheck })}
          />
        ))}
      </div>
    </CardTW>
  );
};
